import { createSlice } from "@reduxjs/toolkit";
import { appConfigs } from "../constants/ApplicationConstants";

const initialState= {
  processing: false,
  pageMessage: null,
  tableAttributes: appConfigs.tableAttributes
}

const appSlice = createSlice({
  name: "app",
  initialState: initialState,
  extraReducers: (builder) => {
    builder
     .addCase('LOGOUT', (state) => {
        Object.assign(state, initialState);
     })
  },
  reducers: {
    setProcessing: (state, action) => {
      state.processing = action.payload
    },
    setPageMessage: (state, action) => {
      state.pageMessage = action.payload
    },
    clearPageMessage:(state)=>{
      state.pageMessage = null
    },
    setTableAttributes: (state, action) => {
      state.tableAttributes = action.payload
    }
  },
});

export const { setProcessing, setPageMessage, clearPageMessage, setTableAttributes } = appSlice.actions;
export default appSlice.reducer;